export const getStyles = (isRtl) => ({
  productsContainer: {
    padding: '40px 20px',
    maxWidth: '1200px',
    margin: '0 auto',
    textAlign: isRtl ? 'right' : 'left',
    direction: isRtl ? 'rtl' : 'ltr'
  },

  header: {
    textAlign: 'center',
    marginBottom: '50px'
  },

  headerTitle: {
    color: 'rgb(154,74,32)',
    fontSize: '2.5rem',
    marginBottom: '16px'
  },

  headerDescription: {
    color: '#666',
    fontSize: '1.1rem',
    maxWidth: '800px',
    margin: '0 auto'
  },

  productsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '30px',
    padding: '20px 0'
  },

  productCard: {
    backgroundColor: '#fff',
    borderRadius: '10px',
    overflow: 'hidden',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  },

  productCardHover: {
    transform: 'translateY(-5px)',
    boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
  },

  productImage: {
    width: '100%',
    height: '250px',
    objectFit: 'cover',
    borderBottom: '1px solid #eee'
  },

  productContent: {
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  },

  productTitle: {
    color: 'rgb(154,74,32)',
    fontSize: '1.5rem',
    marginBottom: '10px',
    fontWeight: '500',
    textAlign: isRtl ? 'right' : 'left'
  },

  productDescription: {
    color: '#666',
    fontSize: '1rem',
    lineHeight: '1.6',
    flex: 1,
    textAlign: isRtl ? 'right' : 'left'
  },

  productCode: {
    color: 'rgb(154,74,32)',
    fontSize: '0.9rem',
    fontWeight: '500',
    padding: '6px 12px',
    backgroundColor: 'rgba(154,74,32,0.1)',
    borderRadius: '4px',
    display: 'inline-block',
    marginTop: '15px'
  },

  '@media (max-width: 768px)': {
    headerTitle: {
      fontSize: '2rem'
    },
    productsGrid: {
      gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
      gap: '20px'
    }
  }
}); 